import { useLocation } from 'react-router-dom'
import styles from './PageTransition.module.css'

interface PageTransitionProps {
  children: React.ReactNode
}

export default function PageTransition({ children }: PageTransitionProps) {
  const location = useLocation()
  return (
    <div key={location.pathname} className={styles.page}>
      {children}
    </div>
  )
}
